<template>
<div>
 <Topmenus></Topmenus>

<!-- Start the code for this screen here -->
 <div class="pagecontainer">
   <div class="container">
     <div class="heading"><span><b>Manage Profile</b></span></div>
     <div v-if="error"> 
       <p align ="center" class="alert-danger"> {{error}} </p>
     </div>
     <div v-if="saved">
       <p align ="center" class="confirm-message"> Password updated successfully </p>
     </div>
     <div class="form-group">
      <div class="col-15">
      <label name="current Password" class="required">Current Password</label>
      </div>
      <div class="col-15">
      <input type="password" autofocus data-vv-as="Current Password" name="cpwd" v-validate="'required'" v-model.trim="profile.currentpwd" placeholder="Enter your password"/>
        <div v-if="errors.has('cpwd')" class="alert-danger" > {{ errors.first('cpwd') }} </div>
      </div>
     </div>
     <br>
      <div class="form-group">
        <div class="col-15">
      <label name="new Password" class="required">New Password </label>
        </div>
      <div class="col-15">
      <input type="password" name="npwd" data-vv-as="New Password" v-validate="'required'" v-model.trim="profile.newpwd" 
      ref="newpassword" placeholder="Enter your password"/>
      <div v-if="errors.has('npwd')" class="alert-danger">{{ errors.first('npwd') }}</div>
      </div>
     </div>
     <br>
      <div class="form-group">
      <div class="col-15">
      <label name="Reenter Password" class="required">ReEnter Password </label>
      </div>
      <div class="col-15">
      <input type="password" name="rpwd" data-vv-as="Password" v-validate="'required|confirmed:newpassword'" v-model.trim="profile.newrentpwd" 
       placeholder="Confirm your password"/>
      <div v-if="errors.has('rpwd')" class="alert-danger">{{ errors.first('rpwd') }}</div>
      </div>
     </div>
     <br>
     <div class="form-group">
       <button type="submit" > Update </button>
     </div>
   </div> <!-- END of Container TAG -->
   </div> <!-- END of PAGE Container TAG -->
  <!-- End of the code for this screen here -->
   <BottomFooter></BottomFooter> 
  </div> 
</template>
<script>
import Topmenus from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
export default {
 components: {
   Topmenus,
   BottomFooter
  
 },
  
  data(){
   return {
    profile: this.initializedata(), // intialize  entry fields
    error :'',
    saved: false,
   };
  },
  methods :{
    initializedata(){
      return {
        currentpwd:"",
        newpwd:"",
        newrentpwd:""
      }
    },
   
}
}
</script>
<style scoped>   
</style>